"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.number.is-safe-integer");

require("core-js/modules/es6.number.constructor");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _styles = require("../../styles");

var _isHexColorValue = _interopRequireDefault(require("../../is-hex-color-value"));

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var DEFAULT_ON_ERROR = function DEFAULT_ON_ERROR() {};

var DEFAULT_WORD_CLOUD_COLOR = _styles.DEFAULT_SERIES_CHART_COLORS[0];
/**
 * A class to represent the visualization options for a Word Cloud Chart
 * @param {object} options options object (See below)
 * @param {boolean} [options.animate=true] Dictate whether to animate the chart when rendering (True=yes, false=no)
 * @param {number} [options.maxPhraseLength=Number.POSITIVE_INFINITY] Maximum character
 * @param {function} [options.onError] A function to handle an error when rendering
 * @param {function} [options.onPointClick] A function to be passed a point data object (ie key, seriesName, value) on click
 * @param {string} [options.seriesColor] An color for word cloud
 * @param {function} [options.tooltipFormatter] A function to be passed a point data object (ie keys, keyIndex, values) on hover
 */

var MwChartWordCloudChartOptions = function MwChartWordCloudChartOptions(options) {
  (0, _classCallCheck2.default)(this, MwChartWordCloudChartOptions);
  var safeOptions = (0, _getValidObject.default)(options);

  if (safeOptions.maxPhraseLength === undefined) {
    safeOptions.maxPhraseLength = Number.POSITIVE_INFINITY;
  } else if (!Number.isSafeInteger(safeOptions.maxPhraseLength)) {
    throw new TypeError("options.maxPhraseLength must be a valid integer. Provided value: ".concat(JSON.stringify(safeOptions.maxPhraseLength)));
  }

  if (safeOptions.onError === undefined) {
    safeOptions.onError = DEFAULT_ON_ERROR;
  } else if (typeof safeOptions.onError !== 'function') {
    throw new TypeError("options.onError must be a function. Provided value: ".concat(safeOptions.onError));
  }

  if (typeof safeOptions.onPointClick !== 'function' && safeOptions.onPointClick !== undefined) {
    throw new TypeError("options.onPointClick must be a function. Provided value: ".concat(safeOptions.onPointClick));
  }

  if (safeOptions.seriesColor === undefined) {
    safeOptions.seriesColor = DEFAULT_WORD_CLOUD_COLOR;
  } else if (!(0, _isHexColorValue.default)(safeOptions.seriesColor)) {
    throw new TypeError("options.seriesColor must be a valid hex color. Provided value: ".concat(JSON.stringify(safeOptions.seriesColor)));
  }

  if (typeof safeOptions.tooltipFormatter !== 'function' && safeOptions.tooltipFormatter !== undefined) {
    throw new TypeError("options.tooltipFormatter must be a function. Provided value: ".concat(JSON.stringify(safeOptions.tooltipFormatter)));
  }

  this.animate = safeOptions.animate !== false;
  this.maxPhraseLength = safeOptions.maxPhraseLength;
  this.onError = safeOptions.onError;
  this.onPointClick = safeOptions.onPointClick;
  this.seriesColor = safeOptions.seriesColor;
  this.tooltipFormatter = safeOptions.tooltipFormatter;
  Object.freeze(this);
};

exports.default = MwChartWordCloudChartOptions;